import { Reveal } from "../lib/motion";

export const Chapter = ({ index, label, dark = false }) => (
  <Reveal>
    <p
      data-testid={`chapter-${String(index)}`}
      className={`font-mono text-xs md:text-[13px] font-medium tracking-[0.18em] uppercase ${dark ? "text-ice" : "text-pine"}`}
    >
      [ {index} ] {label}
    </p>
  </Reveal>
);
